/**
 * Auth use cases – sign in, sign up, sign out. Delegates to Firebase Auth.
 */
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
} from 'firebase/auth';
import { auth } from '../../data/firebase/config';
import { userRepo } from '../../data/repositories/UserRepository';
import { createUser } from '../entities/User';

export async function signUp(email, password, displayName, { referredBy = null } = {}) {
  const cred = await createUserWithEmailAndPassword(auth, email, password);
  const userDoc = {
    displayName: displayName || cred.user.email?.split('@')[0] || 'Athlete',
    role: 'user',
    createdAt: new Date(),
  };
  if (referredBy && typeof referredBy === 'string') {
    userDoc.referredBy = referredBy.trim().toLowerCase();
  }
  await userRepo.set(cred.user.uid, userDoc);
  return cred.user;
}

export async function signIn(email, password) {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  return cred.user;
}

export async function signOut() {
  await firebaseSignOut(auth);
}

export function getCurrentUser() {
  return auth.currentUser;
}
